module.exports = __webpack_public_path__ + "assets/img/b58947213eaf62376b849151d42aa1f3.svg";